import {Pipe, PipeTransform} from '@angular/core';
import {TrackerMetricTypes} from 'src/app/trackers/shared/tracker-metric-types';

@Pipe({
  name: 'metricDisplay',
  standalone: true,
})
export class MetricDisplayPipe implements PipeTransform {
  transform(value: string, type: TrackerMetricTypes): string {
    if (type === TrackerMetricTypes.Boolean) {
      if (value === '0') {
        return 'No';
      } else if (value === '1') {
        return 'Yes';
      } else {
        return value;
      }
    }
    return value;
  }
}
